/**
 * TerraToggle — side tab anchored to the right edge that opens the
 * TERRA panel. Replaces the previous floating-action-button so it
 * stops covering site content.
 */
import { useTerraStore } from '@/store/terra';
import { SideTab } from '@/components/SideTab';

export function TerraToggle() {
  const { isOpen, toggle } = useTerraStore();

  return (
    <SideTab
      label="TERRA"
      title="Open TERRA Assistant"
      accent="cyan"
      bottom={24}
      hidden={isOpen}
      onClick={toggle}
    />
  );
}
